import React from "react";
import LayeredDataCore from "./LayeredDataCore";
import styles from "./ImageCarousel.module.css";
import { slides } from "../contents/slidesData";
import { scrollToSection, sectionIds } from "../utils/scroll";
import ArrowLinkButton from "./ArrowLinkButton";

function ImageCarousel() {
  const heroTitle = "IT Lösungen, die Komplexität reduzieren und Kosten senken";
  const heroSlide =
    slides.find((slide) => slide.title.startsWith("Maßgeschneiderte")) ||
    slides[0];

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.heroLayout}>
        <div className={styles.overlay}>
          <h2 className={styles.title}>
            <span className={styles.titleLine}>
              {heroTitle}
              <span className={styles.titleAccent}>.</span>
            </span>
          </h2>
          <p className={styles.content}>{heroSlide.content}</p>
          <div className={styles.actions}>
            <button
              className={styles.button}
              onClick={() => scrollToSection(sectionIds.contact)}
              type="button"
            >
              Jetzt starten
            </button>
            <ArrowLinkButton
              className={styles.secondaryAction}
              onClick={() => scrollToSection(sectionIds.whyUs)}
            >
              Mehr erfahren
            </ArrowLinkButton>
          </div>
        </div>
        <div className={styles.visualWrap}>
          <LayeredDataCore />
        </div>
      </div>
    </div>
  );
}

export default ImageCarousel;
